(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (!document.querySelector('.ad-hero')) return;
    const link = event.target.closest('header-drawer a[href^="#"]');
    if (!link) return;
    const drawer = link.closest('header-drawer');
    if (typeof drawer.closeMenuDrawer === 'function') {
      drawer.closeMenuDrawer(event, drawer.querySelector('summary'));
      drawer.querySelector('summary').setAttribute('aria-expanded', 'false');
    }
  });
  } catch(e) { console.error(e); }
})();

})();
